import { render, staticRenderFns } from "./InsertUsersCalendars.vue?vue&type=template&id=31060c32"
import script from "./InsertUsersCalendars.vue?vue&type=script&lang=js"
export * from "./InsertUsersCalendars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports